import React, { useState, useEffect } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Checkbox,
	FormControlLabel
} from "@mui/material";
import moment from "moment";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import SearchIcon from "@mui/icons-material/Search";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import { useSelector, useDispatch } from "react-redux";
import { FormControl } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useHistory, useNavigate } from "react-router-dom";
import { Card, Alert } from "reactstrap";
import SOLogout from "../../components/Logout/SOLogout";
import { AiOutlineSearch } from "react-icons/ai";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns"
import "jspdf-autotable";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import { dealerGetTransactionMasterList } from "../../redux/actions/dealerGetTransactionMasterListAction";
import { getTransactionTypeListDetails } from "../../redux/actions/getTransactionTypeListAction";
import Layout from "../../components/Wrappers/Layout";
import Excel from "../../assets/img/excel.png";
import PDF from "../../assets/img/pdf1.png";
import Util from "../../validation/index";
import { dealerWalletExcelPdfFileList } from '../../redux/actions/dealerWalletExcelPdfFileAction'

const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});
const DealerWalletTransaction = () => {
	const csv = "1";
	const pdf = "0";
	const [isLoading, setIsLoading] = useState(true);
	const navigate = useHistory();

	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(5);

	const [getTransactionMasterListStatus, setGetTransactionMasterListStatus] =
		useState(false);
	const [getTransactionMasterListArray, setGetTransactionMasterListArray] =
		useState([]);

	const [getTransactionTypeListResArray, setGetTransactionTypeListResArray] =
		useState([]);
	const [getTransactionTypeListStatus, setGetTransactionTypeListStatus] =
		useState(false);

	const [getSummeryReportFileResStatus, setGetSummeryReportFileRes] =
		useState(false)

	const [getTranactionId, setTransactionId] = useState("");
	const [transactionType, setTransactionType] = useState("");
	const [isFee, setIsFee] = useState("");
	const [getFromCustomerId, setGetFromCustomerId] = useState("");
	const [getDsrContact, setGetDsrContact] = useState("");
	const [getCustomerContact, setGetCustomerContact] = useState("");
	const [editCurrency, setEditCurrency] = useState("");

	var date = new Date();
	const [selectedDate, setSelectedDate] = useState(
		new Date(date.getFullYear(), date.getMonth(), 1)
	);
	const [selectedToDate, setSelectedToDate] = useState(new Date());
	const handleDateChange = (date) => {
		setSelectedDate(date);
	};
	const handleToDateChange = (date) => {
		setSelectedToDate(date);
	};

	const getDealerTransactionMasterList = useSelector(
		({ dealerGetTransactionMasterLists }) => dealerGetTransactionMasterLists
	);

	const getTransactionTypeListRes = useSelector(
		({ getTransactionTypeList }) => getTransactionTypeList
	);

	const getWalletExcelPdfFileRes = useSelector(
		({ dealerWalletExcelPdfFiles }) => dealerWalletExcelPdfFiles
	);
	const dispatch = useDispatch();
	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleChange = ({ target: { name, value } }) => {
		if (name === "transactionId") {
			// setTransactionId(value);
			Util.verifyNumber(value)
				? setTransactionId(value)
				: setTransactionId(getTranactionId);
		}
		// if (name === "transactionType") {
		//     setTransactionType(value == "Select Transaction Type" ? "" : value);

		// }
		if (name === "transactionType") {
			setTransactionType(value == "Select Transaction Type" ? "" : value);
			// setTransactionType(value);
		}
		if (name === "fromCustomerId") {
			Util.verifyNumber(value)
				? setGetFromCustomerId(value)
				: setGetFromCustomerId(getFromCustomerId);
		}
		if (name === "DSRContact") {
			setGetDsrContact(value);
		}
		if (name === "ToCustomerContact") {
			setGetCustomerContact(value);
		}
		if (name === "Currency") {
			setEditCurrency(value == "Select Currency" ? "" : value);
		}
		if (name === "IsFee") {
			setIsFee(value == "All" ? "" : value);
		}
	};
	var authToken = regenerateTokenRes.data.AuthToken;
	const classes = useStyles();
	const getTransactionTypeListReqApi = () => {
		setGetTransactionTypeListStatus(true);
		const getTransactionTypeListReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			}
		};

		return dispatch(
			getTransactionTypeListDetails(getTransactionTypeListReq, authToken)
		);
	};

	const GetTransactionTypeListFunc = () => {
		if (getTransactionTypeListStatus) {
			if (getTransactionTypeListRes.data.status == "success") {
				setGetTransactionTypeListResArray(
					getTransactionTypeListRes.data.transactionType
				);
			}
			if (getTransactionTypeListRes.data.status == "failed") {
				setGetTransactionTypeListResArray(getTransactionTypeListRes.data);
				if (
					getTransactionTypeListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getTransactionTypeListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		GetTransactionTypeListFunc();
	}, [getTransactionTypeListRes.data.status]);

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getTransactionTypeListReqApi();
		}
	}, [regenerateTokenRes.data.status]);

	const getDealerTransactionMasterListReq = () => {
		setIsLoading(true);
		setGetTransactionMasterListStatus(true);
		let req = {
			actionCustomerMasterRequestVO: {
				dealerId: regenerateTokenRes.data.partnerId || "",
				// walletOwnerId: regenerateTokenRes.data.partnerId || "",
				fdtstamp: moment(selectedDate).format("YYYY-MM-DD"),
				tdtstamp: moment(selectedToDate).format("YYYY-MM-DD"),
				customerId: getFromCustomerId,
				transactionId: getTranactionId,
				transactionType: transactionType,
				currency: editCurrency,
				isFee: isFee
				// transactionType == "All" ? "" : transactionType,

				// transactionAmount: getTransactionAmount,
				// dsrContact: getDsrContact,
				// customerContact: getCustomerContact,
				// currency: editCurrency == "All" ? "" : editCurrency,
			}
		};
		dispatch(dealerGetTransactionMasterList(req, authToken));
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getDealerTransactionMasterListReq();
		}
	}, [regenerateTokenRes.data.status]);

	const getTransactionMasterListResFunc = () => {
		if (getTransactionMasterListStatus) {
			if (getDealerTransactionMasterList.data.status == "success") {
				setIsLoading(false);
				setGetTransactionMasterListArray(
					[].concat(getDealerTransactionMasterList.data.transactionList)
				);
			}
			if (getDealerTransactionMasterList.data.status == "failed") {
				setIsLoading(false);
				setGetTransactionMasterListArray(getDealerTransactionMasterList.data);
				if (
					getDealerTransactionMasterList.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getDealerTransactionMasterList.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}

			if (getDealerTransactionMasterList.data.status == "Not Found") {
				setIsLoading(false);
				setGetTransactionMasterListArray(getDealerTransactionMasterList.data);
			}
		}
	};
	useEffect(() => {
		getTransactionMasterListResFunc();
	}, [getDealerTransactionMasterList.data.status]);

	const getSummeryReportFileExcelOrPdf = (csvOrPdf) => {
		setGetSummeryReportFileRes(true);
		let req = {

			actionCustomerMasterRequestVO: {
				dealerId: regenerateTokenRes.data.partnerId || "",
				currency: "BDT",
				fdtStamp: moment(selectedDate).format("DD/MM/YYYY"),
				tdtStamp: moment(selectedToDate).format("DD/MM/YYYY"),
				transactionId: getTranactionId,
				isFee: isFee,
				customerId: getFromCustomerId,
				reportFileType: csvOrPdf == "1" ? "csv" : "pdf",
				transactionType: transactionType,
				// transactionSubType: transactionSubType,

			}
		};

		return dispatch(dealerWalletExcelPdfFileList(req, authToken));
	};

	useEffect(() => {
		if (getSummeryReportFileResStatus) {
			if (getWalletExcelPdfFileRes.data.status == "success") {
				var link = document.createElement("a");
				link.download = getWalletExcelPdfFileRes.data.fileName;
				link.href =
					"data:application/octet-stream;base64," +
					getWalletExcelPdfFileRes.data.fileDate.split(`,`)[1];
				link.click();
			}
		}
	}, [getWalletExcelPdfFileRes.data.status]);

	useEffect(() => {
		if (getWalletExcelPdfFileRes.data.status == "success") {
			setPage(0);
		}
	}, [getWalletExcelPdfFileRes.data.status]);
	return (
		<>
			<Layout>
				<Card>
					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<FormControl fullWidth>
								 <LocalizationProvider dateAdapter={AdapterDateFns}>
									<DatePicker
										label="From Date"
										format="MM-dd-yyyy"
										value={selectedDate}
										onChange={handleDateChange}
										disableFuture={true}
									/>
								  </LocalizationProvider>
							</FormControl>
						</Grid>

						<Grid item xs={12} sm={12} md={3} lg={3}>
							<FormControl fullWidth>
								 <LocalizationProvider dateAdapter={AdapterDateFns}>
									<DatePicker
										label="To Date"
										format="MM-dd-yyyy"
										value={selectedToDate}
										onChange={handleToDateChange}
										disableFuture={true}
									/>
								  </LocalizationProvider>
							</FormControl>
						</Grid>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								required
								size="small"
								color="primary"
								type="text"
								label="From Customer ID"
								fullWidth={true}
								name="fromCustomerId"
								value={getFromCustomerId}
								onChange={handleChange}
								// onChange={onInputChange}
								// onChange={(e) => onInputChange(e, "number")}
								style={{ marginTop: "3px" }}
							></TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								// required
								size="small"
								color="primary"
								type="text"
								label="Transaction ID"
								fullWidth={true}
								name="transactionId"
								value={getTranactionId}
								onChange={handleChange}
								// onChange={onInputChange}
								// onChange={(e) => onInputChange(e, "number")}
								style={{ marginTop: "3px" }}
							></TextField>
						</Grid>

						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								style={{ marginTop: "3px" }}
								select
								autoFocus
								margin="dense"
								id="name"
								label="Transaction Type"
								type="name"
								fullWidth
								name="transactionType"
								value={transactionType || ""}
								onChange={handleChange}
							// onChange={(e) => onInputChange(e)}
							>
								<MenuItem
									value="Select Transaction Type"
									selected="Select Transaction Type"
								>
									Select Transaction Type
								</MenuItem>
								{getTransactionTypeListRes.success &&
									getTransactionTypeListRes.data.transactionType.map((x) => (
										<MenuItem value={x}>{x}</MenuItem>
									))}
							</TextField>
						</Grid>

						{/* <Grid item xs={12} sm={12} md={3} lg={3}>
                            <TextField
                                // required
                                size="small"
                                color="primary"
                                type="text"
                                label="DSR Contact"
                                fullWidth={true}
                                name="DSRContact"
                                value={getDsrContact}
                                onChange={handleChange}
                                // onChange={onInputChange}
                                // onChange={(e) => onInputChange(e, "number")}
                                style={{ marginTop: "3px" }}
                            ></TextField>
                        </Grid> */}
						{/* <Grid item xs={12} sm={12} md={3} lg={3}>
                            <TextField
                                // required
                                size="small"
                                color="primary"
                                type="text"
                                label="To Customer Contact"
                                fullWidth={true}
                                name="ToCustomerContact"
                                value={getCustomerContact}
                                onChange={handleChange}
                                // onChange={onInputChange}
                                // onChange={(e) => onInputChange(e, "number")}
                                style={{ marginTop: "3px" }}
                            ></TextField>
                        </Grid> */}
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								required
								style={{ marginTop: "3px" }}
								select
								autoFocus
								margin="dense"
								label="Currency"
								fullWidth
								name="Currency"
								// value={"Select Currency" || editCurrency}
								defaultValue={"Select Currency" || editCurrency}
								onChange={handleChange}
							// onChange={(e) => onInputChange(e)}
							>
								<MenuItem value="Select Currency" selected="Select Currency">
									Select Currency
								</MenuItem>
								<MenuItem value="BDT">BDT</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								style={{ marginTop: "3px" }}
								select
								autoFocus
								// margin="dense"

								label="Is Fee"
								fullWidth
								name="IsFee"
								defaultValue={isFee || "All"}
								onChange={handleChange}
							// onChange={(e) => onInputChange(e)}
							>
								<MenuItem value="All" selected="All">
									All
								</MenuItem>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={6} md={3} lg={3}>
							{/* <Button
                                style={{
                                    backgroundColor: "#00b9f5",
                                    color: "white",
                                    marginTop: "16px",
                                }}
                                endIcon={<AiOutlineSearch />}
                                variant="contained"
                                onClick={getDsrMasterListReq}
                            >
                                Search
                            </Button> */}
							<CustomButton
								style={{
									padding: "8px",
									margin: "15px 8px"
								}}
								endIcon={<AiOutlineSearch />}
								variant="contained"
								onClick={getDealerTransactionMasterListReq}
							>
								Search
								<SearchIcon style={{ marginLeft: "4px", fontSize: "21px" }} />
							</CustomButton>
						</Grid>
					</Grid>
				</Card>
				{isLoading ? (
					<LoadingSpinner />
				) : getTransactionMasterListArray.length == undefined ||
					!getTransactionMasterListStatus ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography variant="body1" style={{ fontWeight: "700" }}>
									Report Table
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 themeBackground"
									variant="secondary"
									style={{ color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<div>
						<Card>
							<Grid
								container
								style={{
									padding: "10px"
								}}
							>
								<Grid xs={12} sm={12} md={12} lg={12}>
									<Typography variant="body1" style={{ fontWeight: "700" }}>
										Report Table
									</Typography>
								</Grid>
								<Grid
									container
									style={{
										padding: "10px",
										textAlign: "center",
										justifyContent: "right"
									}}
								>
									<Grid
										container
										style={{
											padding: "10px",
											textAlign: "center",
											justifyContent: "right",
											gap: "10px"
										}}
									>
										<Grid item xs={4} sm={4} md={1} lg={1}>

											<img
												src={Excel}
												style={{ height: "30px", cursor: "pointer" }}
												onClick={() => {
													getSummeryReportFileExcelOrPdf(csv)
												}}
											></img>
										</Grid>
										<Grid item xs={4} sm={4} md={1} lg={1}>

											<img
												src={PDF}
												style={{ height: "30px", cursor: "pointer" }}
												onClick={() => {
													getSummeryReportFileExcelOrPdf(pdf)
												}}
											></img>
										</Grid>
									</Grid>
								</Grid>
								<TableContainer component={Paper} className="text-nowrap my-3">
									<Table className={classes.table}>
										<TableHead>
											<TableRow
												style={{ background: "#00b9f5" }}
												className="themeBackground"
											>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													{" "}
													Transaction date
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													{" "}
													Transaction id
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													{" "}
													Transaction type
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Transaction amount{" "}
												</TableCell>

												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Dsr Contact
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													To customer
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													{" "}
													To Customer Contact
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													{" "}
													Commission
												</TableCell>
												{/* <TableCell align="center" style={{ fontWeight: "bold", color: "white" }}> Commission</TableCell> */}
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													{" "}
													Credit
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													{" "}
													Debit
												</TableCell>

												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													{" "}
													Balance
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													{" "}
													Transaction Status
												</TableCell>

												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Remark
												</TableCell>
											</TableRow>
										</TableHead>

										<TableBody>
											{getTransactionMasterListArray &&
												[]
													.concat(getTransactionMasterListArray)
													.slice(
														page * rowsPerPage,
														page * rowsPerPage + rowsPerPage
													)
													.map((row, index) => (
														<TableRow key={index}>
															<TableCell align="center">
																{row.fromDate}
															</TableCell>
															<TableCell align="center">
																{row.transactionId}
															</TableCell>

															<TableCell align="center">
																{row.transactionType}
															</TableCell>
															<TableCell align="center">
																{row.transactionAmount}
															</TableCell>
															<TableCell align="center">
																{row.dsrContact}
															</TableCell>
															<TableCell align="center">
																{row.toCustomerName}
															</TableCell>
															<TableCell align="center">
																{row.toCustomerContact}
															</TableCell>
															<TableCell align="center">
																{row.toCustomerContact}
															</TableCell>
															<TableCell align="center">
																{row.creditAmount}
															</TableCell>
															<TableCell align="center">
																{row.debitAmount}
															</TableCell>
															<TableCell align="center">
																{row.balance}
															</TableCell>
															<TableCell align="center">
																{row.transactionStatus}
															</TableCell>
															<TableCell align="center">{row.remark}</TableCell>
														</TableRow>
													))}
										</TableBody>
									</Table>
									<TablePagination
										rowsPerPageOptions={[5, 10, 25]}
										component="div"
										count={[].concat(getTransactionMasterListArray).length}
										rowsPerPage={rowsPerPage}
										page={page}
										onChangePage={handleChangePage}
										onChangeRowsPerPage={handleChangeRowsPerPage}
									/>
								</TableContainer>
							</Grid>
						</Card>
					</div>
				)}
			</Layout>
		</>
	);
};

export default DealerWalletTransaction;
